import React, { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import AdminLayout from "./Components/Admin/AdminLayout";

// Route-level code splitting — each page's bundle only loads when that
// route is actually visited, instead of all pages loading up front.
const Login = lazy(() => import("./Pages/Login"));
const SupplierRegister = lazy(() => import("./Pages/SupplierRegister"));
const SupplierDashboard = lazy(() => import("./Pages/SupplierDashboard"));
const SupplierResubmit = lazy(() => import("./Pages/SupplierResubmit"));
const SupplierTenders = lazy(() => import("./Pages/SupplierTenders"));
const SupplierAdditionalSupplyRequests = lazy(() => import("./Pages/AdditionalSupplyRequests"));
const SupplierProducts = lazy(() => import("./Pages/SupplierProducts"));
const SupplierDeliveries = lazy(() => import("./Pages/SupplierDeliveries"));
const SupplierSourceDeclarations = lazy(() => import("./Pages/SupplierSourceDeclarations"));
const SupplierReplacementNotices = lazy(() => import("./Pages/ReplacementNotices"));
const SupplierReplacementNoticeDetail = lazy(() => import("./Pages/ReplacementNoticeDetail"));
const SupplierCertificates = lazy(() => import("./Pages/SupplierCertificates"));
const SupplierImportRecords = lazy(() => import("./Pages/SupplierImportRecords"));
const Dashboard = lazy(() => import("./Pages/Admin/Dashboard"));
const SupplierQueue = lazy(() => import("./Pages/Admin/SupplierQueue"));
const SupplierDetail = lazy(() => import("./Pages/Admin/SupplierDetail"));
const MyIndents = lazy(() => import("./Pages/Admin/MyIndents"));
const CreateIndent = lazy(() => import("./Pages/Admin/CreateIndent"));
const IndentDetail = lazy(() => import("./Pages/Admin/IndentDetail"));
const EditIndent = lazy(() => import("./Pages/Admin/EditIndent"));
const CwsUserManagement = lazy(() => import("./Pages/Admin/CwsUserManagement"));
const MfUserManagement = lazy(() => import("./Pages/Admin/MfUserManagement"));
const IndentReview = lazy(() => import("./Pages/Admin/IndentReview"));
const IndentReviewDetail = lazy(() => import("./Pages/Admin/IndentReviewDetail"));
const IndentDemand = lazy(() => import("./Pages/Admin/IndentDemand"));
const IndentDemandDetail = lazy(() => import("./Pages/Admin/IndentDemandDetail"));
const CwsCompanies = lazy(() => import("./Pages/Admin/CwsCompanies"));
const CompanyDetail = lazy(() => import("./Pages/Admin/CompanyDetail"));
const CompanyEdit = lazy(() => import("./Pages/Admin/CompanyEdit"));
const CompanyCreate = lazy(() => import("./Pages/Admin/CompanyCreate"));
const StoreManagement = lazy(() => import("./Pages/Admin/StoreManagement"));
const ProductMaster = lazy(() => import("./Pages/Admin/ProductMaster"));
const ProcurementProducts = lazy(() => import("./Pages/Admin/ProcurementProducts"));
const CwsBranches = lazy(() => import("./Pages/Admin/CwsBranches"));
const TenderList = lazy(() => import("./Pages/Admin/TenderList"));
const CreateTender = lazy(() => import("./Pages/Admin/CreateTender"));
const TenderDetail = lazy(() => import("./Pages/Admin/TenderDetail"));
const PriceReview = lazy(() => import("./Pages/Admin/PriceReview"));
const SupplementaryRequests = lazy(() => import("./Pages/Admin/SupplementaryRequests"));
const SupplementaryRequestDetail = lazy(() => import("./Pages/Admin/SupplementaryRequestDetail"));
const MismatchReports = lazy(() => import("./Pages/Admin/MismatchReports"));
const ReplacementNotices = lazy(() => import("./Pages/Admin/ReplacementNotices"));
const ReplacementsExpected = lazy(() => import("./Pages/Admin/ReplacementsExpected"));
const QualityCheckReview = lazy(() => import("./Pages/Admin/QualityCheckReview"));
const QualityCheckAdd = lazy(() => import("./Pages/Admin/QualityCheckAdd"));
const QualityCheckHistory = lazy(() => import("./Pages/Admin/QualityCheckHistory"));
const RateFixingReview = lazy(() => import("./Pages/Admin/RateFixingReview"));
const RateFixingBulkEntry = lazy(() => import("./Pages/Admin/RateFixingBulkEntry"));
const RateFixingProductDetail = lazy(() => import("./Pages/Admin/RateFixingProductDetail"));
const RateFixingSessionDetail = lazy(() => import("./Pages/Admin/RateFixingSessionDetail"));
const RateFixingSourceMaster = lazy(() => import("./Pages/Admin/RateFixingSourceMaster"));
const Settings = lazy(() => import("./Pages/Admin/Settings"));
const SettingsLoginAdvertisement = lazy(() => import("./Pages/Admin/SettingsLoginAdvertisement"));
const ProductAttributeMaster = lazy(() => import("./Pages/Admin/ProductAttributeMaster"));
const RateFixingHistory = lazy(() => import("./Pages/Admin/RateFixingHistory"));
const RateFixingHistorySessionDetail = lazy(() => import("./Pages/Admin/RateFixingHistorySessionDetail"));
const RcsDashboard = lazy(() => import("./Pages/Admin/RcsDashboard"));
const RcsRateFixingHistory = lazy(() => import("./Pages/Admin/RcsRateFixingHistory"));
const RcsRateFixingHistorySessionDetail = lazy(() => import("./Pages/Admin/RcsRateFixingHistorySessionDetail"));
const RcsReplacementNotices = lazy(() => import("./Pages/Admin/RcsReplacementNotices"));
const CmsSourceDeclarations = lazy(() => import("./Pages/Admin/CmsSourceDeclarations"));
const CmsSourceDeclarationDetail = lazy(() => import("./Pages/Admin/CmsSourceDeclarationDetail"));
const SupplyMonitoring = lazy(() => import("./Pages/Admin/SupplyMonitoring"));
const ProductLists = lazy(() => import("./Pages/Admin/ProductLists"));
const ProductListAssignments = lazy(() => import("./Pages/Admin/ProductListAssignments"));
const DocumentTemplateEditor = lazy(() => import("./Pages/Admin/DocumentTemplateEditor"));
const GenerateJpcMinutes = lazy(() => import("./Pages/Admin/GenerateJpcMinutes"));
const Reports = lazy(() => import("./Pages/Admin/Reports"));
const SupplierEntityTypeGate = lazy(() => import("./Components/SupplierEntityTypeGate"));
const BrandedVendors = lazy(() => import("./Pages/Admin/BrandedVendors"));
const BrandedVendorDetail = lazy(() => import("./Pages/Admin/BrandedVendorDetail"));
const DirectPoList = lazy(() => import("./Pages/Admin/DirectPoList"));
const DirectPoCreate = lazy(() => import("./Pages/Admin/DirectPoCreate"));
const DirectPoDetail = lazy(() => import("./Pages/Admin/DirectPoDetail"));
const ManualSupplyOrderList = lazy(() => import("./Pages/Admin/ManualSupplyOrderList"));
const ManualSupplyOrderCreate = lazy(() => import("./Pages/Admin/ManualSupplyOrderCreate"));
const ManualSupplyOrderDetail = lazy(() => import("./Pages/Admin/ManualSupplyOrderDetail"));
const StoreSupplyOrders = lazy(() => import("./Pages/Admin/StoreSupplyOrders"));
const StoreSupplyOrderDetail = lazy(() => import("./Pages/Admin/StoreSupplyOrderDetail"));
// FMCG catalogue + FMCG indents (2026-10-07)
const FmcgProductMaster = lazy(() => import("./Pages/Admin/FmcgProductMaster"));
const FmcgIndents = lazy(() => import("./Pages/Admin/FmcgIndents"));
const FmcgIndentDetail = lazy(() => import("./Pages/Admin/FmcgIndentDetail"));
const FmcgIndentForm = lazy(() => import("./Pages/Admin/FmcgIndentForm"));
const MyFmcgIndents = lazy(() => import("./Pages/Admin/MyFmcgIndents"));
// FMCG supply orders (2026-10-08)
const FmcgSummary = lazy(() => import("./Pages/Admin/FmcgSummary"));
const FmcgMasters = lazy(() => import("./Pages/Admin/FmcgMasters"));
const FmcgSupplierProducts = lazy(() => import("./Pages/Admin/FmcgSupplierProducts"));
const FmcgSupplyOrders = lazy(() => import("./Pages/Admin/FmcgSupplyOrders"));
const FmcgSupplyOrderCreate = lazy(() => import("./Pages/Admin/FmcgSupplyOrderCreate"));
const FmcgSupplyOrderDetail = lazy(() => import("./Pages/Admin/FmcgSupplyOrderDetail"));
const MyFmcgSupplyOrders = lazy(() => import("./Pages/Admin/MyFmcgSupplyOrders"));
const MyFmcgSupplyOrderDetail = lazy(() => import("./Pages/Admin/MyFmcgSupplyOrderDetail"));
const SupplierFmcgSupplyOrders = lazy(() => import("./Pages/SupplierFmcgSupplyOrders"));
const SupplierFmcgSupplyOrderDetail = lazy(() => import("./Pages/SupplierFmcgSupplyOrderDetail"));
const SupplierSupplyOrders = lazy(() => import("./Pages/SupplierSupplyOrders"));
const SupplierSupplyOrderDetail = lazy(() => import("./Pages/SupplierSupplyOrderDetail"));

// Reviewer roles (Super Admin/Admin/TNCCF Office/TNCCF Head) land on the
// supplier queue; CWS Admin/User land on their own indents — mirrors
// Utils/adminAuth.js's REVIEWER_ROLE_IDS without importing it here, to
// keep this file dependency-free for the route-guard logic below.
const REVIEWER_ROLE_IDS = [1, 2, 5, 7];
// CWS Admin(3)/CWS User(4) — mirrors Utils/adminAuth.js's CWS_ROLE_IDS,
// duplicated here for the same dependency-free reason as above.
const CWS_ROLE_IDS = [3, 4];
// CWS Admin only — mirrors Utils/adminAuth.js's CWS_ADMIN_ROLE_IDS,
// same dependency-free duplication as above. Gates CWS User management
// and the indent approval queue specifically.
const CWS_ADMIN_ROLE_IDS = [3];
// Marketing Federation Admin(12)/User(13) — same use case as CWS,
// mirrors Utils/adminAuth.js's MF_ROLE_IDS, same dependency-free
// duplication as above.
const MF_ROLE_IDS = [12, 13];
// Marketing Federation Admin only — mirrors Utils/adminAuth.js's
// MF_ADMIN_ROLE_IDS, same dependency-free duplication as above.
const MF_ADMIN_ROLE_IDS = [12];
// TNCCF Office(5) OR Head(7) — mirrors Utils/adminAuth.js's
// MISMATCH_REVIEWER_ROLE_IDS (v3, 2026-08-07 — widened from
// PRICE_VIEWER_ROLE_IDS since this workflow has nothing to do with prices).
const MISMATCH_REVIEWER_ROLE_IDS = [5, 7];
// TNCCF Head only — mirrors Utils/adminAuth.js's PRICE_VIEWER_ROLE_IDS,
// same dependency-free duplication as above. The ONLY role that may
// reach the price-comparison/allocation screen.
const PRICE_VIEWER_ROLE_IDS = [7];
// Quality Check Committee only — mirrors Utils/adminAuth.js's
// QUALITY_CHECK_ROLE_IDS, same dependency-free duplication as above.
const QUALITY_CHECK_ROLE_IDS = [8];
// Rate Fixing Committee only — mirrors Utils/adminAuth.js's
// RATE_FIXING_ROLE_IDS, same dependency-free duplication as above.
const RATE_FIXING_ROLE_IDS = [10];
// RCS only — mirrors Utils/adminAuth.js's RCS_ROLE_IDS, same
// dependency-free duplication as above.
const RCS_ROLE_IDS = [11];
// Read-only Replacement Notices history for RCS — mirrors Utils/
// adminAuth.js's REPLACEMENT_NOTICE_VIEWER_ROLE_IDS, same
// dependency-free duplication as above.
const REPLACEMENT_NOTICE_VIEWER_ROLE_IDS = [...MISMATCH_REVIEWER_ROLE_IDS, ...RCS_ROLE_IDS];
// Read-only CMS purchase-source declaration oversight for TNCCF Head +
// RCS — mirrors Utils/adminAuth.js's CMS_DECLARATION_VIEWER_ROLE_IDS,
// same dependency-free duplication as above.
const CMS_DECLARATION_VIEWER_ROLE_IDS = [...PRICE_VIEWER_ROLE_IDS, ...RCS_ROLE_IDS];
// Product List management — mirrors Utils/adminAuth.js's
// PRODUCT_LIST_MANAGER_ROLE_IDS, same dependency-free duplication.
const PRODUCT_LIST_MANAGER_ROLE_IDS = [1, 2, 5, 7];
// TNCCF Office + TNCCF Head only — mirrors Utils/adminAuth.js's
// COMPANY_EDITOR_ROLE_IDS, same dependency-free duplication. Gates
// /admin/companies/:cmp_id/edit specifically; the view page and the
// list itself stay open to every REVIEWER_ROLE_IDS role.
const COMPANY_EDITOR_ROLE_IDS = [5, 7];
// Reports page (Indent Report + Supply Order Report) — mirrors Utils/
// adminAuth.js's REPORT_VIEWER_ROLE_IDS, same dependency-free
// duplication as above. CWS (own company) + every TNCCF reviewer role
// + RCS.
const REPORT_VIEWER_ROLE_IDS = [...CWS_ROLE_IDS, ...MF_ROLE_IDS, ...REVIEWER_ROLE_IDS, ...RCS_ROLE_IDS];
// RCS view-only widening (2026-08-16) — mirrors Utils/adminAuth.js's
// PROCUREMENT_VIEWER_ROLE_IDS, same dependency-free duplication as
// above. Gates Indent Submitted, Product Demand, Registered
// Participants, Supply Monitoring, and CWS Stores — view-only routes,
// never a write/action route.
const PROCUREMENT_VIEWER_ROLE_IDS = [...REVIEWER_ROLE_IDS, ...RCS_ROLE_IDS];
// Procurement (tenders) — mirrors Utils/adminAuth.js's
// TENDER_VIEWER_ROLE_IDS, same dependency-free duplication as above.
const TENDER_VIEWER_ROLE_IDS = [...REVIEWER_ROLE_IDS, ...RCS_ROLE_IDS];
// Mismatch Reports listing only — mirrors Utils/adminAuth.js's
// MISMATCH_REPORT_VIEWER_ROLE_IDS, same dependency-free duplication.
const MISMATCH_REPORT_VIEWER_ROLE_IDS = [...MISMATCH_REVIEWER_ROLE_IDS, ...RCS_ROLE_IDS];
// Grievance Redressal (9) — role row only so far, no real page built
// yet (client: "later ill tell what their login needs"). Without this
// branch this role fell into the CWS_ROLE_IDS-only "/admin/indents"
// default below and got redirected straight back out by that route's
// own role gate — an infinite redirect loop, found and fixed
// 2026-07-29 before it ever shipped (Rate Fixing Committee hit the
// same bug until its real page was built the same day).
const PLACEHOLDER_ROLE_IDS = [9];
// Branded Vendors & Direct POs (2026-09-27) — mirrors Utils/adminAuth.js's
// BRANDED_VENDOR_*_ROLE_IDS, same dependency-free duplication as above.
const BRANDED_VENDOR_MANAGER_ROLE_IDS = [5, 7];
const BRANDED_VENDOR_VIEWER_ROLE_IDS = [1, 2, 5, 7, 11];
// Manual Supply Orders (2026-10-02) — mirrors Utils/adminAuth.js.
const MANUAL_SUPPLY_ORDER_MANAGER_ROLE_IDS = [5, 7];
const MANUAL_SUPPLY_ORDER_VIEWER_ROLE_IDS = [1, 2, 5, 7, 11];
// Store logins (CWS + Marketing Federation) see the supply orders placed for their own store.
const STORE_SUPPLY_ORDER_ROLE_IDS = [3, 4, 12, 13];
// FMCG (2026-10-07) — mirrors Utils/adminAuth.js / controller/procurement/fmcg.js.
const FMCG_VIEWER_ROLE_IDS = [1, 2, 5, 7, 11];
const FMCG_STORE_ROLE_IDS = [3, 4, 12, 13];
const FMCG_MANAGER_ROLE_IDS = [5, 7];
const adminHomePath = () => {
  try {
    const info = JSON.parse(localStorage.getItem("admin_info"));
    if (QUALITY_CHECK_ROLE_IDS.includes(info?.role_id)) return "/admin/quality-check";
    if (RATE_FIXING_ROLE_IDS.includes(info?.role_id)) return "/admin/rate-fixing";
    if (RCS_ROLE_IDS.includes(info?.role_id)) return "/admin/rcs-dashboard";
    if (PLACEHOLDER_ROLE_IDS.includes(info?.role_id)) return "/admin/coming-soon";
    // TNCCF (reviewer roles) and CWS both land on the new stats
    // dashboard now (added 2026-08-02) — their old landing pages
    // (/admin/suppliers, /admin/indents) are still reachable via nav.
    if (REVIEWER_ROLE_IDS.includes(info?.role_id) || CWS_ROLE_IDS.includes(info?.role_id) || MF_ROLE_IDS.includes(info?.role_id)) return "/admin/dashboard";
    return "/admin/login";
  } catch {
    return "/admin/login";
  }
};

// Same guard logic as the ERP's SupplierProtectedRoute/SupplierPublicRoute —
// checks supplier_token/supplier_isAuthenticated (Utils/supplierAuth.js),
// which is the only identity this app knows about.
const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("supplier_token");
  const isAuthenticated = localStorage.getItem("supplier_isAuthenticated");

  if (!token || !isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // SHG / FPO / JLG split (2026-09-25): a supplier still on the legacy
  // combined 'SHG_FPO' type must choose one before carrying on. Only
  // loaded when the stored session says SHG_FPO or predates this change
  // (no entity_type stored) — everyone else never downloads it.
  let storedEntityType;
  try {
    storedEntityType = JSON.parse(localStorage.getItem("supplier_info"))?.entity_type;
  } catch {
    storedEntityType = undefined;
  }
  if (storedEntityType === "SHG_FPO" || storedEntityType === undefined) {
    return (
      <>
        {children}
        <Suspense fallback={null}>
          <SupplierEntityTypeGate />
        </Suspense>
      </>
    );
  }

  return children;
};

// /login is now the single entry point for both identity spaces (see
// Pages/Login.jsx) — this guard checks BOTH sessions and redirects
// straight to whichever home page already applies, instead of just the
// supplier one.
const PublicRoute = ({ children }) => {
  const supplierToken = localStorage.getItem("supplier_token");
  const supplierAuthenticated = localStorage.getItem("supplier_isAuthenticated");
  if (supplierToken && supplierAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  const adminToken = localStorage.getItem("admin_token");
  const adminAuthenticated = localStorage.getItem("admin_isAuthenticated");
  if (adminToken && adminAuthenticated) {
    return <Navigate to={adminHomePath()} replace />;
  }

  return children;
};

// Admin/TNCCF guard — separate localStorage keys (Utils/adminAuth.js)
// from the supplier ones above, mirroring the backend's own token
// isolation (ADMIN_JWT_SECRET vs SUPPLIER_JWT_SECRET). A supplier session
// must never grant access to /admin/* routes or vice versa. Redirects to
// the unified /login (not a separate /admin/login) when unauthenticated.
//
// Optional `roles` prop enforces which role_ids may reach this route —
// e.g. a CWS Admin typing /admin/suppliers directly must not reach the
// supplier queue just because NAV_ITEMS hides the link. This mirrors
// (does not replace) the backend's own role checks in each controller;
// it only avoids showing a logged-in-but-unauthorized user the wrong
// page. Redirects to their own home rather than /login, since they ARE
// authenticated — just not permitted here.
const AdminProtectedRoute = ({ children, roles }) => {
  const token = localStorage.getItem("admin_token");
  const isAuthenticated = localStorage.getItem("admin_isAuthenticated");

  if (!token || !isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (roles) {
    let roleId;
    try {
      roleId = JSON.parse(localStorage.getItem("admin_info"))?.role_id;
    } catch {
      roleId = null;
    }
    if (!roles.includes(roleId)) {
      return <Navigate to={adminHomePath()} replace />;
    }
  }

  return children;
};

const RouteFallback = () => (
  <div className="flex items-center justify-center min-h-screen">
    <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-blue-600" />
  </div>
);

// Landing page for Grievance Redressal / Rate Fixing Committee — these
// roles exist (mst_jpc_role) and can log in, but have no real screens
// yet. A plain inline component (not lazy-loaded/its own file) since
// it's a temporary stand-in, not a real feature — replace with an
// actual page once each role's requirements are given. Still wrapped in
// AdminLayout (not a bare div) so these users get the header/profile-
// menu/logout every other logged-in page has — without it they'd be
// stuck logged in with no way to sign out.
const ComingSoonPage = () => (
  <AdminLayout>
    <div className="flex items-center justify-center py-20 px-4">
      <div className="text-center max-w-md">
        <h1 className="text-xl font-bold text-[#1a1a1a] mb-2">Coming Soon</h1>
        <p className="text-sm text-[#757575]">
          Your account is set up, but this role's dashboard hasn't been built yet — check back soon.
        </p>
      </div>
    </div>
  </AdminLayout>
);

function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={<RouteFallback />}>
        <Routes>
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route
            path="/login"
            element={
              <PublicRoute>
                <Login />
              </PublicRoute>
            }
          />
          {/* Old direct link — same unified login now lives at /login */}
          <Route path="/admin/login" element={<Navigate to="/login" replace />} />
          <Route
            path="/register"
            element={
              <PublicRoute>
                <SupplierRegister />
              </PublicRoute>
            }
          />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <SupplierDashboard />
              </ProtectedRoute>
            }
          />
          {/* Not gated by ProtectedRoute — a Rejected supplier has no
              full login token at all (see supplier_auth.js's
              /login/request-otp), so this page authenticates itself via
              its own narrow mobile+OTP flow, same reasoning /register
              and /login are public routes. */}
          <Route path="/resubmit" element={<SupplierResubmit />} />
          <Route
            path="/tenders"
            element={
              <ProtectedRoute>
                <SupplierTenders />
              </ProtectedRoute>
            }
          />
          <Route
            path="/tenders/:tender_id"
            element={
              <ProtectedRoute>
                <SupplierTenders />
              </ProtectedRoute>
            }
          />
          <Route
            path="/products"
            element={
              <ProtectedRoute>
                <SupplierProducts />
              </ProtectedRoute>
            }
          />
          <Route
            path="/deliveries"
            element={
              <ProtectedRoute>
                <SupplierDeliveries />
              </ProtectedRoute>
            }
          />
          <Route
            path="/supply-orders"
            element={
              <ProtectedRoute>
                <SupplierSupplyOrders />
              </ProtectedRoute>
            }
          />
          <Route path="/fmcg-supply-orders" element={<ProtectedRoute><SupplierFmcgSupplyOrders /></ProtectedRoute>} />
          <Route path="/fmcg-supply-orders/:order_id" element={<ProtectedRoute><SupplierFmcgSupplyOrderDetail /></ProtectedRoute>} />
          <Route
            path="/supply-orders/:order_id"
            element={
              <ProtectedRoute>
                <SupplierSupplyOrderDetail />
              </ProtectedRoute>
            }
          />

          {/* CMS suppliers only — the monthly purchase-source declaration.
              The page itself explains the restriction for a non-CMS
              supplier, and every API call is gated server-side on
              supplier_type. */}
          <Route
            path="/source-declarations"
            element={
              <ProtectedRoute>
                <SupplierSourceDeclarations />
              </ProtectedRoute>
            }
          />

          {/* Importer suppliers only — import (Bill of Entry) records for
              their listed products. Gated server-side on supplier_type. */}
          <Route
            path="/import-records"
            element={
              <ProtectedRoute>
                <SupplierImportRecords />
              </ProtectedRoute>
            }
          />

          {/* Split out of SupplierDeliveries.jsx (client ask, 2026-08-07:
              "have separate page for the replacement notice"), then
              split list/detail (same day: "have view page separately
              for the Replacement Notices"). */}
          <Route
            path="/additional-supply-requests"
            element={
              <ProtectedRoute>
                <SupplierAdditionalSupplyRequests />
              </ProtectedRoute>
            }
          />
          <Route
            path="/replacement-notices"
            element={
              <ProtectedRoute>
                <SupplierReplacementNotices />
              </ProtectedRoute>
            }
          />
          <Route
            path="/replacement-notices/:notice_id"
            element={
              <ProtectedRoute>
                <SupplierReplacementNoticeDetail />
              </ProtectedRoute>
            }
          />
          <Route
            path="/certificates"
            element={
              <ProtectedRoute>
                <SupplierCertificates />
              </ProtectedRoute>
            }
          />

          {/* TNCCF/reviewer + CWS — landing-page stats dashboard (added 2026-08-02) */}
          <Route
            path="/admin/dashboard"
            element={
              <AdminProtectedRoute roles={[...REVIEWER_ROLE_IDS, ...CWS_ROLE_IDS, ...MF_ROLE_IDS]}>
                <Dashboard />
              </AdminProtectedRoute>
            }
          />

          <Route
            path="/admin/suppliers"
            element={
              <AdminProtectedRoute roles={PROCUREMENT_VIEWER_ROLE_IDS}>
                <SupplierQueue />
              </AdminProtectedRoute>
            }
          />
          <Route
            path="/admin/suppliers/:supplier_id"
            element={
              <AdminProtectedRoute roles={PROCUREMENT_VIEWER_ROLE_IDS}>
                <SupplierDetail />
              </AdminProtectedRoute>
            }
          />

          {/* CWS Admin/User + Marketing Federation Admin/User (same use
              case) — purchase indent submission */}
          <Route
            path="/admin/indents"
            element={
              <AdminProtectedRoute roles={[...CWS_ROLE_IDS, ...MF_ROLE_IDS]}>
                <MyIndents />
              </AdminProtectedRoute>
            }
          />
          <Route
            path="/admin/indents/new"
            element={
              <AdminProtectedRoute roles={[...CWS_ROLE_IDS, ...MF_ROLE_IDS]}>
                <CreateIndent />
              </AdminProtectedRoute>
            }
          />
          <Route
            path="/admin/indents/:indent_id"
            element={
              <AdminProtectedRoute roles={[...CWS_ROLE_IDS, ...MF_ROLE_IDS]}>
                <IndentDetail />
              </AdminProtectedRoute>
            }
          />
          <Route
            path="/admin/indents/:indent_id/edit"
            element={
              <AdminProtectedRoute roles={[...CWS_ROLE_IDS, ...MF_ROLE_IDS]}>
                <EditIndent />
              </AdminProtectedRoute>
            }
          />

          {/* CWS Admin only (added 2026-08-13) — manage CWS User
              sub-accounts. Approving/rejecting a 'Pending Approval'
              indent happens on the existing My Indents / Indent Detail
              pages (widened to show the whole company's indents for
              an Admin) — no separate approvals page, per client ask. */}
          <Route
            path="/admin/cws-users"
            element={
              <AdminProtectedRoute roles={CWS_ADMIN_ROLE_IDS}>
                <CwsUserManagement />
              </AdminProtectedRoute>
            }
          />

          {/* Marketing Federation Admin only — same use case as the CWS
              route above, its own separate page/dataset. */}
          <Route
            path="/admin/mf-users"
            element={
              <AdminProtectedRoute roles={MF_ADMIN_ROLE_IDS}>
                <MfUserManagement />
              </AdminProtectedRoute>
            }
          />

          {/* CWS Admin/User + Marketing Federation + RCS (added
              2026-08-07) — read-only view of products available for
              procurement (English + Tamil name); distinct from
              /admin/products, which is the reviewer-only CRUD master */}
          <Route
            path="/admin/procurement-products"
            element={
              <AdminProtectedRoute roles={[...CWS_ROLE_IDS, ...MF_ROLE_IDS, ...RCS_ROLE_IDS]}>
                <ProcurementProducts />
              </AdminProtectedRoute>
            }
          />

          {/* CWS Admin/User + Marketing Federation (added 2026-08-13) —
              read-only listing of their own company's branches/godowns. */}
          <Route
            path="/admin/branches"
            element={
              <AdminProtectedRoute roles={[...CWS_ROLE_IDS, ...MF_ROLE_IDS]}>
                <CwsBranches />
              </AdminProtectedRoute>
            }
          />

          {/* TNCCF/reviewer — cross-company indent visibility */}
          <Route
            path="/admin/indent-review"
            element={
              <AdminProtectedRoute roles={PROCUREMENT_VIEWER_ROLE_IDS}>
                <IndentReview />
              </AdminProtectedRoute>
            }
          />
          <Route
            path="/admin/indent-review/:indent_id"
            element={
              <AdminProtectedRoute roles={PROCUREMENT_VIEWER_ROLE_IDS}>
                <IndentReviewDetail />
              </AdminProtectedRoute>
            }
          />

          {/* TNCCF/reviewer — "is Product Supplied or not" monitoring */}
          <Route
            path="/admin/supply-monitoring"
            element={
              <AdminProtectedRoute roles={PROCUREMENT_VIEWER_ROLE_IDS}>
                <SupplyMonitoring />
              </AdminProtectedRoute>
            }
          />

          {/* CWS (own company) + TNCCF reviewer roles + RCS — Indent Report + Supply Order Report */}
          <Route
            path="/admin/reports"
            element={
              <AdminProtectedRoute roles={REPORT_VIEWER_ROLE_IDS}>
                <Reports />
              </AdminProtectedRoute>
            }
          />

          {/* Super Admin/Admin/TNCCF Office only — Product Lists (excludes TNCCF Head) */}
          <Route
            path="/admin/product-lists"
            element={
              <AdminProtectedRoute roles={PRODUCT_LIST_MANAGER_ROLE_IDS}>
                <ProductLists />
              </AdminProtectedRoute>
            }
          />
          <Route
            path="/admin/product-list-assignments"
            element={
              <AdminProtectedRoute roles={PRODUCT_LIST_MANAGER_ROLE_IDS}>
                <ProductListAssignments />
              </AdminProtectedRoute>
            }
          />

          {/* Supply Order / JPC Minutes document builder (added 2026-08-01) */}
          <Route
            path="/admin/document-templates"
            element={
              <AdminProtectedRoute roles={PRODUCT_LIST_MANAGER_ROLE_IDS}>
                <DocumentTemplateEditor />
              </AdminProtectedRoute>
            }
          />
          <Route
            path="/admin/minutes/generate"
            element={
              <AdminProtectedRoute roles={PRODUCT_LIST_MANAGER_ROLE_IDS}>
                <GenerateJpcMinutes />
              </AdminProtectedRoute>
            }
          />

          {/* TNCCF/reviewer — indent demand aggregated by product */}
          <Route
            path="/admin/indent-demand"
            element={
              <AdminProtectedRoute roles={PROCUREMENT_VIEWER_ROLE_IDS}>
                <IndentDemand />
              </AdminProtectedRoute>
            }
          />
          <Route
            path="/admin/indent-demand/:product_id"
            element={
              <AdminProtectedRoute roles={PROCUREMENT_VIEWER_ROLE_IDS}>
                <IndentDemandDetail />
              </AdminProtectedRoute>
            }
          />

          {/* TNCCF/reviewer — CWS company master listing */}
          <Route
            path="/admin/companies"
            element={
              <AdminProtectedRoute roles={PROCUREMENT_VIEWER_ROLE_IDS}>
                <CwsCompanies />
              </AdminProtectedRoute>
            }
          />
          <Route
            path="/admin/companies/new"
            element={
              <AdminProtectedRoute roles={COMPANY_EDITOR_ROLE_IDS}>
                <CompanyCreate />
              </AdminProtectedRoute>
            }
          />
          <Route
            path="/admin/companies/:cmp_id"
            element={
              <AdminProtectedRoute roles={PROCUREMENT_VIEWER_ROLE_IDS}>
                <CompanyDetail />
              </AdminProtectedRoute>
            }
          />
          <Route
            path="/admin/companies/:cmp_id/edit"
            element={
              <AdminProtectedRoute roles={COMPANY_EDITOR_ROLE_IDS}>
                <CompanyEdit />
              </AdminProtectedRoute>
            }
          />
          <Route
            path="/admin/stores"
            element={
              <AdminProtectedRoute roles={COMPANY_EDITOR_ROLE_IDS}>
                <StoreManagement />
              </AdminProtectedRoute>
            }
          />

          {/* TNCCF/reviewer — curated JPC product list */}
          <Route
            path="/admin/products"
            element={
              <AdminProtectedRoute roles={REVIEWER_ROLE_IDS}>
                <ProductMaster />
              </AdminProtectedRoute>
            }
          />

          {/* TNCCF/reviewer — tender pooling */}
          <Route
            path="/admin/tenders"
            element={
              <AdminProtectedRoute roles={TENDER_VIEWER_ROLE_IDS}>
                <TenderList />
              </AdminProtectedRoute>
            }
          />
          <Route
            path="/admin/tenders/new"
            element={
              <AdminProtectedRoute roles={REVIEWER_ROLE_IDS}>
                <CreateTender />
              </AdminProtectedRoute>
            }
          />
          <Route
            path="/admin/tenders/:tender_id"
            element={
              <AdminProtectedRoute roles={TENDER_VIEWER_ROLE_IDS}>
                <TenderDetail />
              </AdminProtectedRoute>
            }
          />

          {/* TNCCF Head only — sealed price-comparison/split-award screen */}
          <Route
            path="/admin/price-review"
            element={
              <AdminProtectedRoute roles={PRICE_VIEWER_ROLE_IDS}>
                <PriceReview />
              </AdminProtectedRoute>
            }
          />
          <Route
            path="/admin/price-review/:tender_id/:tender_product_id"
            element={
              <AdminProtectedRoute roles={PRICE_VIEWER_ROLE_IDS}>
                <PriceReview />
              </AdminProtectedRoute>
            }
          />

          {/* TNCCF Head only — supplementary (post-procurement) indent
              ask/hold decisions. Same OTP-gated posture as Price Review. */}
          <Route
            path="/admin/supplementary-requests"
            element={
              <AdminProtectedRoute roles={PRICE_VIEWER_ROLE_IDS}>
                <SupplementaryRequests />
              </AdminProtectedRoute>
            }
          />
          <Route
            path="/admin/supplementary-requests/:indent_item_id"
            element={
              <AdminProtectedRoute roles={PRICE_VIEWER_ROLE_IDS}>
                <SupplementaryRequestDetail />
              </AdminProtectedRoute>
            }
          />

          {/* TNCCF Office or Head — review queue for quality-mismatch reports;
              v3 (2026-08-07) reinstates the Issue Notice / Waive decision. */}
          <Route
            path="/admin/mismatch-reports"
            element={
              <AdminProtectedRoute roles={MISMATCH_REPORT_VIEWER_ROLE_IDS}>
                <MismatchReports />
              </AdminProtectedRoute>
            }
          />

          {/* CWS stores + Marketing Federation — confirm a replacement
              actually arrived. Their confirmation is what closes a
              replacement notice. */}
          <Route
            path="/admin/quality-quantity-management"
            element={
              <AdminProtectedRoute roles={[...CWS_ROLE_IDS, ...MF_ROLE_IDS]}>
                <ReplacementsExpected />
              </AdminProtectedRoute>
            }
          />

          {/* TNCCF Office or Head — the replacement-notice queue, and the one
              manual decision left: blocklist or excuse a supplier who missed
              the fixed 3-day replacement window */}
          <Route
            path="/admin/replacement-notices"
            element={
              <AdminProtectedRoute roles={MISMATCH_REVIEWER_ROLE_IDS}>
                <ReplacementNotices />
              </AdminProtectedRoute>
            }
          />

          {/* Quality Check Committee only — flat product+supplier quality check log, decoupled from tenders */}
          <Route
            path="/admin/quality-check"
            element={
              <AdminProtectedRoute roles={QUALITY_CHECK_ROLE_IDS}>
                <QualityCheckReview />
              </AdminProtectedRoute>
            }
          />
          <Route
            path="/admin/quality-check/new"
            element={
              <AdminProtectedRoute roles={QUALITY_CHECK_ROLE_IDS}>
                <QualityCheckAdd />
              </AdminProtectedRoute>
            }
          />

          {/* TNCCF Head only — read-only view of the Quality Check
              Committee's records (client ask: "need to show this to the
              tnccf head"), same posture as RateFixingHistory below (no
              OTP step-up — no price figures here). */}
          <Route
            path="/admin/quality-check-history"
            element={
              <AdminProtectedRoute roles={PRICE_VIEWER_ROLE_IDS}>
                <QualityCheckHistory />
              </AdminProtectedRoute>
            }
          />

          {/* Rate Fixing Committee only — list of bulk rate submissions (View icon -> session detail below) */}
          <Route
            path="/admin/rate-fixing"
            element={
              <AdminProtectedRoute roles={RATE_FIXING_ROLE_IDS}>
                <RateFixingReview />
              </AdminProtectedRoute>
            }
          />
          {/* Rate Fixing Committee only — one bulk submission's full detail (every product it covered + shared documents) */}
          <Route
            path="/admin/rate-fixing/sessions/:session_id"
            element={
              <AdminProtectedRoute roles={RATE_FIXING_ROLE_IDS}>
                <RateFixingSessionDetail />
              </AdminProtectedRoute>
            }
          />
          {/* Rate Fixing Committee only — one product's full rate history, reached via "History" on the Bulk Rate Update page */}
          <Route
            path="/admin/rate-fixing/products/:product_id"
            element={
              <AdminProtectedRoute roles={RATE_FIXING_ROLE_IDS}>
                <RateFixingProductDetail />
              </AdminProtectedRoute>
            }
          />
          {/* Rate Fixing Committee only — the editable multi-source grid + bulk session submit, reached via "Bulk Rate Update" above */}
          <Route
            path="/admin/rate-fixing/bulk-entry"
            element={
              <AdminProtectedRoute roles={RATE_FIXING_ROLE_IDS}>
                <RateFixingBulkEntry />
              </AdminProtectedRoute>
            }
          />
          {/* Rate Fixing Committee only — market source master (add/rename/activate/deactivate) */}
          <Route
            path="/admin/rate-fixing/sources"
            element={
              <AdminProtectedRoute roles={RATE_FIXING_ROLE_IDS}>
                <RateFixingSourceMaster />
              </AdminProtectedRoute>
            }
          />
          {/* TNCCF Office/Head only — general settings hub (a menu, not any one feature directly) */}
          <Route
            path="/admin/settings"
            element={
              <AdminProtectedRoute roles={COMPANY_EDITOR_ROLE_IDS}>
                <Settings />
              </AdminProtectedRoute>
            }
          />
          {/* TNCCF Office/Head only — login-page advertisement, reached via the Settings hub above */}
          <Route
            path="/admin/settings/login-advertisement"
            element={
              <AdminProtectedRoute roles={COMPANY_EDITOR_ROLE_IDS}>
                <SettingsLoginAdvertisement />
              </AdminProtectedRoute>
            }
          />
          {/* Category/Sub-Category/Brand master feeding ProductMaster.jsx's
              Add/Edit Select dropdowns (client ask, 2026-09-19). Gated
              REVIEWER_ROLE_IDS, NOT COMPANY_EDITOR_ROLE_IDS — deliberately
              the same role set that manages products themselves (Super
              Admin/Admin/TNCCF Office/Head), matching the backend's own
              requireProductAttributeEditor gate in jpc_product.js. Gating
              this to COMPANY_EDITOR_ROLE_IDS (TNCCF Office/Head only,
              like the rest of Settings) would leave Super Admin/Admin
              unable to add a brand-new category/brand while adding a
              product — reached via the Settings hub for TNCCF Office/
              Head, and a direct link on ProductMaster.jsx itself for
              Super Admin/Admin, who don't see the Settings nav item at
              all (see AdminHeader.jsx). */}
          <Route
            path="/admin/settings/product-attributes"
            element={
              <AdminProtectedRoute roles={REVIEWER_ROLE_IDS}>
                <ProductAttributeMaster />
              </AdminProtectedRoute>
            }
          />

          {/* TNCCF Head only — read-only view of the Rate Fixing Committee's
              submissions (client ask, 2026-08-06: "need to show this details
              to TNCCF Head as a separate menu"). Own OTP step-up gate inside
              the page itself, same posture as Price Review. */}
          <Route
            path="/admin/rate-fixing-history"
            element={
              <AdminProtectedRoute roles={PRICE_VIEWER_ROLE_IDS}>
                <RateFixingHistory />
              </AdminProtectedRoute>
            }
          />
          <Route
            path="/admin/rate-fixing-history/sessions/:session_id"
            element={
              <AdminProtectedRoute roles={PRICE_VIEWER_ROLE_IDS}>
                <RateFixingHistorySessionDetail />
              </AdminProtectedRoute>
            }
          />

          {/* RCS only (added 2026-08-07) — own dashboard (products count +
              quick links), read-only Rate Fixing Committee submission
              history. No second OTP step-up (unlike TNCCF Head) — just
              the one login-time OTP. */}
          <Route
            path="/admin/rcs-dashboard"
            element={
              <AdminProtectedRoute roles={RCS_ROLE_IDS}>
                <RcsDashboard />
              </AdminProtectedRoute>
            }
          />
          <Route
            path="/admin/rcs-rate-fixing"
            element={
              <AdminProtectedRoute roles={RCS_ROLE_IDS}>
                <RcsRateFixingHistory />
              </AdminProtectedRoute>
            }
          />
          <Route
            path="/admin/rcs-rate-fixing/sessions/:session_id"
            element={
              <AdminProtectedRoute roles={RCS_ROLE_IDS}>
                <RcsRateFixingHistorySessionDetail />
              </AdminProtectedRoute>
            }
          />

          {/* Replacement Notices — read-only history for RCS (added per
              client ask: "they can see the notices history only view not
              to take any action"). TNCCF Office/Head keep using the full
              action-carrying page at /admin/replacement-notices. */}
          <Route
            path="/admin/notices-history"
            element={
              <AdminProtectedRoute roles={REPLACEMENT_NOTICE_VIEWER_ROLE_IDS}>
                <RcsReplacementNotices />
              </AdminProtectedRoute>
            }
          />

          {/* CMS purchase-source declarations — read-only oversight for
              TNCCF Head + RCS (added per client ask: "this updates from
              the cms need to be shown to the tnccf head and the rcs"). */}
          <Route
            path="/admin/cms-source-declarations"
            element={
              <AdminProtectedRoute roles={CMS_DECLARATION_VIEWER_ROLE_IDS}>
                <CmsSourceDeclarations />
              </AdminProtectedRoute>
            }
          />
          <Route
            path="/admin/cms-source-declarations/:declaration_id"
            element={
              <AdminProtectedRoute roles={CMS_DECLARATION_VIEWER_ROLE_IDS}>
                <CmsSourceDeclarationDetail />
              </AdminProtectedRoute>
            }
          />

          {/* Branded Vendors + direct purchase orders (2026-09-27) — view for
              Super Admin/Admin/TNCCF/RCS; creating a PO is TNCCF Office/Head
              only. Each page also hides its own actions for read-only roles. */}
          <Route
            path="/admin/branded-vendors"
            element={
              <AdminProtectedRoute roles={BRANDED_VENDOR_VIEWER_ROLE_IDS}>
                <BrandedVendors />
              </AdminProtectedRoute>
            }
          />
          <Route
            path="/admin/branded-vendors/new"
            element={
              <AdminProtectedRoute roles={BRANDED_VENDOR_MANAGER_ROLE_IDS}>
                <BrandedVendorDetail />
              </AdminProtectedRoute>
            }
          />
          <Route
            path="/admin/branded-vendors/:vendor_id"
            element={
              <AdminProtectedRoute roles={BRANDED_VENDOR_VIEWER_ROLE_IDS}>
                <BrandedVendorDetail />
              </AdminProtectedRoute>
            }
          />
          <Route
            path="/admin/direct-po"
            element={
              <AdminProtectedRoute roles={BRANDED_VENDOR_VIEWER_ROLE_IDS}>
                <DirectPoList />
              </AdminProtectedRoute>
            }
          />
          <Route
            path="/admin/direct-po/new"
            element={
              <AdminProtectedRoute roles={BRANDED_VENDOR_MANAGER_ROLE_IDS}>
                <DirectPoCreate />
              </AdminProtectedRoute>
            }
          />
          <Route
            path="/admin/direct-po/:po_id"
            element={
              <AdminProtectedRoute roles={BRANDED_VENDOR_VIEWER_ROLE_IDS}>
                <DirectPoDetail />
              </AdminProtectedRoute>
            }
          />
          <Route
            path="/admin/manual-supply-orders"
            element={
              <AdminProtectedRoute roles={MANUAL_SUPPLY_ORDER_VIEWER_ROLE_IDS}>
                <ManualSupplyOrderList />
              </AdminProtectedRoute>
            }
          />
          <Route
            path="/admin/manual-supply-orders/new"
            element={
              <AdminProtectedRoute roles={MANUAL_SUPPLY_ORDER_MANAGER_ROLE_IDS}>
                <ManualSupplyOrderCreate />
              </AdminProtectedRoute>
            }
          />
          <Route
            path="/admin/manual-supply-orders/:order_id"
            element={
              <AdminProtectedRoute roles={MANUAL_SUPPLY_ORDER_VIEWER_ROLE_IDS}>
                <ManualSupplyOrderDetail />
              </AdminProtectedRoute>
            }
          />
          <Route
            path="/admin/store-supply-orders"
            element={
              <AdminProtectedRoute roles={STORE_SUPPLY_ORDER_ROLE_IDS}>
                <StoreSupplyOrders />
              </AdminProtectedRoute>
            }
          />
          <Route
            path="/admin/store-supply-orders/:order_id"
            element={
              <AdminProtectedRoute roles={STORE_SUPPLY_ORDER_ROLE_IDS}>
                <StoreSupplyOrderDetail />
              </AdminProtectedRoute>
            }
          />

          {/* FMCG catalogue + FMCG indents (2026-10-07) */}
          <Route path="/admin/fmcg-products" element={<AdminProtectedRoute roles={FMCG_VIEWER_ROLE_IDS}><FmcgProductMaster /></AdminProtectedRoute>} />
          <Route path="/admin/fmcg-summary" element={<AdminProtectedRoute roles={FMCG_VIEWER_ROLE_IDS}><FmcgSummary /></AdminProtectedRoute>} />
          <Route path="/admin/fmcg-masters" element={<AdminProtectedRoute roles={FMCG_VIEWER_ROLE_IDS}><FmcgMasters /></AdminProtectedRoute>} />
          <Route path="/admin/fmcg-supplier-products" element={<AdminProtectedRoute roles={FMCG_VIEWER_ROLE_IDS}><FmcgSupplierProducts /></AdminProtectedRoute>} />
          <Route path="/admin/fmcg-indents" element={<AdminProtectedRoute roles={FMCG_VIEWER_ROLE_IDS}><FmcgIndents /></AdminProtectedRoute>} />
          <Route path="/admin/fmcg-indents/my" element={<AdminProtectedRoute roles={FMCG_STORE_ROLE_IDS}><MyFmcgIndents /></AdminProtectedRoute>} />
          <Route path="/admin/fmcg-indents/my/:fmcg_indent_id" element={<AdminProtectedRoute roles={FMCG_STORE_ROLE_IDS}><FmcgIndentDetail /></AdminProtectedRoute>} />
          <Route path="/admin/fmcg-indents/:fmcg_indent_id" element={<AdminProtectedRoute roles={FMCG_VIEWER_ROLE_IDS}><FmcgIndentDetail /></AdminProtectedRoute>} />
          <Route path="/admin/fmcg-indent" element={<AdminProtectedRoute roles={FMCG_STORE_ROLE_IDS}><FmcgIndentForm /></AdminProtectedRoute>} />
          {/* FMCG supply orders (2026-10-08) */}
          <Route path="/admin/fmcg-supply-orders" element={<AdminProtectedRoute roles={FMCG_VIEWER_ROLE_IDS}><FmcgSupplyOrders /></AdminProtectedRoute>} />
          <Route path="/admin/fmcg-supply-orders/new" element={<AdminProtectedRoute roles={FMCG_MANAGER_ROLE_IDS}><FmcgSupplyOrderCreate /></AdminProtectedRoute>} />
          <Route path="/admin/fmcg-supply-orders/my" element={<AdminProtectedRoute roles={FMCG_STORE_ROLE_IDS}><MyFmcgSupplyOrders /></AdminProtectedRoute>} />
          <Route path="/admin/fmcg-supply-orders/my/:order_id" element={<AdminProtectedRoute roles={FMCG_STORE_ROLE_IDS}><MyFmcgSupplyOrderDetail /></AdminProtectedRoute>} />
          <Route path="/admin/fmcg-supply-orders/:order_id" element={<AdminProtectedRoute roles={FMCG_VIEWER_ROLE_IDS}><FmcgSupplyOrderDetail /></AdminProtectedRoute>} />

          {/* Grievance Redressal — no real page yet */}
          <Route
            path="/admin/coming-soon"
            element={
              <AdminProtectedRoute roles={PLACEHOLDER_ROLE_IDS}>
                <ComingSoonPage />
              </AdminProtectedRoute>
            }
          />

          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
